export const getChatbotStatus = (state) => state.chatbot?.status;
export const getChatAttributes = (state) => state.chatbot?.attributes;
export const getLookupNames = (state) => state.chatbot?.lookupName;
export const getChatOpen = (state) => state.chatbot?.isOpen;
export const getRescueSubmitted = (state) => state.chatbot?.rescueSubmitted;
export const getChatBotParam = (state) => state.chatbot;
export const getChatUnavailable = (state) => state.chatbot?.chatUnavailable;
